// react
import React, { useState, useEffect, useContext} from 'react';

// react component for creating dynamic tables
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// @material-ui/core | components 
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// icons | @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";
import Timeline from "@material-ui/icons/Timeline";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";
import GestaoClienteProntuarioForm from "./GestaoClienteProntuarioForm";
import GestaoProntuarioForm from './GestaoProntarioForm';

// services
import { useGetApi, UsePostApi, UsePutApi, UseDeleteApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { formateDate } from "beaktShared/helpers/masks";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";
const useStyles = makeStyles(styles);

export default function GestaoClienteProntuarioList({ clienteId, estabelecimentoId }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const endPoint = "prontuario/";
    
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});
    const [loadingForm, setLoadingForm] = React.useState(false);
    const [showFormEvolution, setshowFormEvolution] = React.useState(false);
    const [prontuarioId, setProntuarioId] = React.useState(0);

    // Endpoint para busca da lista
    const getEndPoint = () => {
        let endPointGet = ""; 
        endPointGet = endPoint +"byestabelecimento/" + estabelecimentoId + "/" + clienteId;
        return endPointGet;
    }
    
    // Carrega lista de prontuários
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(getEndPoint());

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);
    };
    
    // Novo prontuário
    const handleAdd = item => {
        var newitem = "";
        newitem = {...item};

        if(item.clienteId === "" || item.clienteId === "0")
        {                                     
            showNotification('Informe um cliente para salvar o prontuário.','danger');
            return false; 
        }

        var vefifyExists = list.filter(obj => {
            return obj.prontuarioId === item.prontuarioId;
        });

        if(vefifyExists.length > 0)
        {
            setLoadingForm(true);
            UsePutApi(endPoint,item.prontuarioId,newitem).then(result=>{
                setLoadingForm(false);
                if(result.status !== 200)
                {                                    
                    showNotification(result.message.message,'danger');
                    return false; 
                }
                
                const updateList = list.map(l => (l.prontuarioId === item.prontuarioId ? item : l));
                setListAtualiza(updateList);
                handleView(true);
                showNotification(result.message,'success');
                return true;
            });             
        }
        else
        {    
            setLoadingForm(true);
            UsePostApi(endPoint,newitem).then(result=> {                
                setLoadingForm(false);

                if(result.status !== 201)
                {                                     
                    showNotification(result.message.message,'danger');
                    return false; 
                } 
                
                const addItemList = [...list, result.data];
                setListAtualiza(addItemList); 
                handleView(true);
                showNotification(t('information_message.registered_successfully'),'success');
                return true;
            });         
        }
        
        return false;        
    };
    
    const handleView = (resetItem) => {
        if(resetItem) {
            setItem({});
            setProntuarioId(0);
            sendScrollToTOP();
        }
        let show = showFormView === true ? false : true;
        setshowFormView(show);

        //recarrega a lista
        if (showFormView) {
            setListAtualiza([]); 
        }
    };
    
    // Editar prontuário
    const handleEdit = row => {
        setProntuarioId(row.prontuarioId);
        setItem(row);
        handleView(false);
    };

    // Delete
    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id => {
        var userDeletadoId = session.id;
        UseDeleteApi(endPoint, id, userDeletadoId).then(result=> {
            if(result.status !== 200)
            {                                    
                setAlertDelete({statusAlert:2});
                showNotification(result.message,'danger');
                return false; 
            } 

            var listFiltered = list.filter(obj => {
                return obj.prontuarioId !== id;
            });
            setListAtualiza(listFiltered);                
            setAlertDelete({statusAlert:3}); 
            return true;
        });
    };

    const showAlertDelete = id => {
        setAlertDelete({
            statusAlert:1,
            idToDeleteRecieve:id
        }); 
    }
    
    useEffect(() => {
        if(alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);
    }, [alertDelete]);

    //colunas Table e Ações
    const columnsProp = [
        {
            Header: t('label.registered_in'),
            accessor: "dataCadastro",
            width: 150,
            Cell: (props) => {
                const custom_date = props.value == null ? "" : formateDate(props.value)
                return <span>{custom_date}</span>
            }
        },
        {
            Header: 'Paciente',
            accessor: "clienteNome",
        },
        {
            Header: 'Biomédico',
            accessor: "usuarioNome",
        },
    ];

    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={() => handleEdit(row.original)}>
                        <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <Edit />
                        </Tooltip>
                    </Button>{" "}
                    <Button
                        justIcon
                        round
                        simple
                        color="danger"
                        className="remove"
                        onClick={() => showAlertDelete(row.original.prontuarioId)} >
                        <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <Close />
                        </Tooltip>
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false,
            width: 100,
        }
    ];

    const columns = [...columnsProp, ...columnsAcao];

    const handleEvolution = (value) => {
        setshowFormEvolution(value);
    };

    const sendScrollToTOP = () => {
        const container = document.querySelector('#divscroll');
        container.scrollTop = 0;
        container.behavior = 'smooth';
    }

    const classes = useStyles();
    return (
        <>
            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />
            
            {showFormEvolution &&
                <GestaoProntuarioForm item={list[0]} handleView={handleEvolution} />
            }

            {!showFormEvolution && 
                <>
                {showFormView && 
                    <GestaoClienteProntuarioForm 
                        addItem={handleAdd} 
                        item={item}
                        handleView={handleView} 
                        loading={loadingForm}
                        clienteId={clienteId}
                        prontuarioId={prontuarioId} />}

                {!showFormView &&
                    <GridContainer>
                        <GridItem xs={12}>
                            <Card>
                                <CardHeader color="primary" icon>
                                    <CardIcon color="primary">
                                        <Assignment />
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>{t('sidebar.medical_record')}</h4>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                            <Button
                                                color="primary" 
                                                className={classes.newButton}
                                                onClick={() => handleView(true)}>
                                                {t('button.new')}
                                            </Button>
                                            { 
                                                (list.length > 1) &&
                                                <Button
                                                    color="info" 
                                                    className={classes.textCenter}
                                                    onClick={() => handleEvolution(true)}>
                                                    <Timeline />
                                                    {t('button.evolution')}
                                                </Button>
                                            }
                                        </GridItem>
                                    </GridContainer>

                                    {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                                    <ReactTable
                                        loading={isLoadingList}
                                        data={list}
                                        columns={columns}
                                        filterable={false}
                                        defaultFilterMethod={noCaseSensitive}
                                        defaultPageSize={10}
                                        minRows={5}
                                        showPaginationBottom={true}
                                        className="-striped -highlight"
                                        previousText={t('button.previous')}
                                        nextText={t('button.next')}
                                        loadingText={t('label.loading') + "..."}
                                        noDataText={t('information_message.no_records_found') + "!"}
                                        pageText={t('label.page')}
                                        ofText={t('label.of')}
                                        rowsText={t('label.rows')}
                                    />

                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                }

                {alertDelete.componente}
                </>
            }
        </>
    );
}
